import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=52f0bbd8&scoped=true&"
import script from "./MailList.vue?vue&type=script&lang=js&"
export * from "./MailList.vue?vue&type=script&lang=js&"
import style1 from "./MailList.vue?vue&type=style&index=1&id=52f0bbd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0bbd8",
  null
  
)

export default component.exports